export default __webpack_public_path__ + "static/media/kitchen3-afterD-1920w.4e2f51df.webp";